import { STANDARD_RES_ORDER } from '../../order-define';
export const resStandard = () => {
    return {
        resOrder: STANDARD_RES_ORDER,
        resInterceptor(res) {
            return res.data;
        }
    };
};
